import {TranslateHttpLoader} from '@ngx-translate/http-loader';
import {inject, Injectable} from '@angular/core';
import {TranslateLoader, TranslateService} from '@ngx-translate/core';
import {HttpClient} from '@angular/common/http';
import {firstValueFrom} from 'rxjs';
import {tap} from 'rxjs/operators';

@Injectable({
    providedIn: 'root',
})
export class TranslationLoader extends TranslateHttpLoader {
    constructor(httpClient: HttpClient) {
        const prefix = '/assets/i18n/';
        const suffix = '.json';
        super(httpClient, prefix, suffix);
    }
}

export function labelsInitializer() {
    const translationLoader = inject(TranslateLoader);
    const translate = inject(TranslateService);
    const lang = 'pl';
    return firstValueFrom(
        translationLoader.getTranslation(lang).pipe(
            tap((translations) => {
                translate.setTranslation(lang, translations);
                translate.addLangs([lang]);
                translate.setDefaultLang(lang);
                translate.use(lang);
            })
        )
    );
}
